import _ from 'underscore';
import locationDescriptionTemplate from '../template/location-description.pug';
import schedulingDescriptionTemplate from '../template/scheduling-description.pug';
import keywordDescriptionTemplate from '../template/keyword-description.pug';
import { isRaiseOpportunity } from '../config/index';

import { Formatter } from '../formatter/index';

function mapLocationLevel(level, i18n) {
  const levelNames = [
    i18n.getString('BidAdjustmentOpt_Country'),
    i18n.getString('BidAdjustmentOpt_State'),
    i18n.getString('BidAdjustmentOpt_MetroArea'),
    i18n.getString('BidAdjustmentOpt_City'),
    i18n.getString('BidAdjustmentOpt_PostalCode'),
  ];

  return levelNames[level];
}

function getFormatDetail(isRaise, costDelta, conversionDelta, i18n, formatter) {
  let i18nKey;
  const conversionDeltaRound = Math.round(conversionDelta);

  if (isRaise) {
    i18nKey = conversionDeltaRound === 0 ?
      'BidAdjustmentOpt_RaiseBidAdjustmentDetail_With_Zero_Conversion' :
      'BidAdjustmentOpt_RaiseBidAdjustmentDetail';
  } else {
    i18nKey = conversionDeltaRound === 0 ?
      'BidAdjustmentOpt_LowerBidAdjustmentDetail_With_Zero_Conversion' :
      'BidAdjustmentOpt_LowerBidAdjustmentDetail';
  }
  const formatedDetail = isRaise ?
    i18n.getString(i18nKey, {
      costDelta: formatter.formatCostDelta(costDelta),
      conversionDelta: formatter.formatConversionDelta(conversionDelta),
    }) :
    i18n.getString(i18nKey, {
      negatedCostDelta: formatter.formatCostDelta(costDelta),
      negatedConversionDelta: formatter.formatConversionDelta(conversionDelta),
    });

  return formatedDetail;
}

function getLocationMapper(details, i18n, formatter) {
  return _.chain(details)
    .filter(item => item.bidMultiplier && !_.isEmpty(item.locationNames))
    .map((item) => {
      const isRaise = isRaiseOpportunity(item, 'Location');
      const [firstLocationPart, ...restLocationsParts] = item.locationNames;
      const levelName = mapLocationLevel(item.geoLevelId, i18n);
      const formatedDetail = getFormatDetail(
        isRaise, item.costDelta,
        item.conversionDelta, i18n, formatter
      );
      const description = locationDescriptionTemplate({
        firstLocationPart: `${firstLocationPart}, `,
        restLocationParts: `${restLocationsParts.join(', ')} (${levelName})`,
        isRaise,
        formatedBidMultiplierRange:
          formatter.formatBidMultiplierRange(item.currentBidMultiplier, item.bidMultiplier),
        formatedDetail,
      });

      return _.extend({}, item, { description });
    }).value();
}

function getSchedulingMapper(details, i18n, formatter) {
  return _.map(details, (item) => {
    const isRaise = isRaiseOpportunity(item, 'Scheduling');
    const formatedDetail = getFormatDetail(
      isRaise, item.costDelta,
      item.conversionDelta, i18n, formatter
    );
    const description = schedulingDescriptionTemplate({
      isRaise,
      dateAndTime: formatter.formatSchedulingDatetime(item.periodType, item.fromHour, item.toHour),
      formatedBidMultiplierRange:
        formatter.formatBidMultiplierRange(item.currentBidMultiplier, item.bidMultiplier),
      formatedDetail,
    });

    return _.extend({}, item, { description });
  });
}

function getKeywordMapper(details, i18n, formatter) {
  return _.map(details, (item) => {
    const formatedDetail = i18n.getString('BidAdjustmentOpt_Keyword_BidAdjustmentDetail', {
      conversionRate: formatter.formatConversionRate(item.conversionRate),
    });

    const description = keywordDescriptionTemplate({
      isRaise: isRaiseOpportunity(item, 'Keyword'),
      adgroupName: item.adgroupName,
      keywordName: formatter.formatKeyword(item.keywordName, item.keywordMatchType),
      formatedDetail,
      formatedBidRange: formatter.formatBidRange(item.currentBid, item.suggestedBid),
    });

    return _.extend({}, item, { description });
  });
}

export function getMapper(type, details, i18n) {
  const formatter = new Formatter(i18n);
  const map = {
    Location: getLocationMapper,
    Scheduling: getSchedulingMapper,
    Keyword: getKeywordMapper,
  };

  return map[type](details, i18n, formatter);
}
